export var KeyEventType;
(function (KeyEventType) {
    KeyEventType["Keydown"] = "keydown";
    KeyEventType["Keypress"] = "keypress";
    KeyEventType["Keyup"] = "keyup";
})(KeyEventType || (KeyEventType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/key-handler/KeyEventType.ts
// module id = 615
// module chunks = 3